import React from "react";
import { Container, Carousel, Card } from "react-bootstrap";
import { StarFill, Quote } from "react-bootstrap-icons";
import "./customproduct.scss";

function TestimonialsCarousel() {
  return (
    <section className="testimonials-section">
      <Container className="py-5">

        {/* Section Title */}
        <div className="text-center mb-5">
          <h2 className="section-title">Our Testimonials</h2>
          <p className="section-subtitle">
            What our valued clients say about us
          </p>
        </div>

        <Carousel indicators={false} interval={4000} pause="hover">

          {/* Slide 1 */}
          <Carousel.Item>
            <Card className="testimonial-card colored-card mx-auto">
              <Card.Body>

                <Quote size={40} className="quote-icon" />

                <p className="testimonial-text">
                  UIPlus Technologies delivered an excellent School ERP solution
                  that simplified our operations. Highly professional team.
                </p>

                {/* Star Rating */}
                <div className="star-rating">
                  <StarFill /><StarFill /><StarFill /><StarFill /><StarFill />
                </div>

                <div className="client-info">
                  <img
                    src="/logos/bloosm-school-logo.png"
                    alt="Client"
                    className="client-img"
                  />
                  <div>
                    <h6 className="client-name">Mr. Rajesh Patil</h6>
                    <span className="client-company">
                      Blossom School Teacher
                    </span>
                  </div>
                </div>

              </Card.Body>
            </Card>
          </Carousel.Item>

          {/* Slide 2 */}
          <Carousel.Item>
            <Card className="testimonial-card colored-card mx-auto">
              <Card.Body>

                <Quote size={40} className="quote-icon" />

                <p className="testimonial-text">
                  Their finance application automated our billing and reporting
                  system. Excellent support and timely delivery.
                </p>

                <div className="star-rating">
                  <StarFill /><StarFill /><StarFill /><StarFill /><StarFill />
                </div>

                <div className="client-info">
                  <img
                    src="/logos/gurukrupa-finance.png"
                    alt="Client"
                    className="client-img"
                  />
                  <div>
                    <h6 className="client-name">Mr. Vishal Patil</h6>
                    <span className="client-company">
                      Gurukrupa Finance
                    </span>
                  </div>
                </div>

              </Card.Body>
            </Card>
          </Carousel.Item>

          {/* Slide 3 */}
          <Carousel.Item>
            <Card className="testimonial-card colored-card mx-auto">
              <Card.Body>

                <Quote size={40} className="quote-icon" />

                <p className="testimonial-text">
                  We received a modern, fast, and SEO-friendly website that
                  boosted our online presence significantly.
                </p>

                <div className="star-rating">
                  <StarFill /><StarFill /><StarFill /><StarFill /><StarFill />
                </div>

                <div className="client-info">
                  <img
                    src="/logos/trimurti-logo.jpeg"
                    alt="Client"
                    className="client-img"
                  />
                  <div>
                    <h6 className="client-name">Mr. Amit Deshmukh</h6>
                    <span className="client-company">
                     Trimurti Multi Services
                    </span>
                  </div>
                </div>

              </Card.Body>
            </Card>
          </Carousel.Item>

        </Carousel>

      </Container>
    </section>
  );
}

export default TestimonialsCarousel;

